import { motion } from "framer-motion";
import { MANIFESTO } from "../../lib/site";

export const Manifesto = () => {
  return (
    <section id="why" data-testid="manifesto-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-14 md:mb-20 max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-4">/ 03 — Why Angmish</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.9]">
            The Only Number<br />You Need To Call
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              data-testid={`manifesto-item-${m.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="flex gap-6 md:gap-8 py-10 border-t border-border"
            >
              <span className="font-heading text-5xl md:text-6xl font-black text-border leading-none shrink-0">
                {m.n}
              </span>
              <div>
                <h3 className="font-heading text-xl md:text-2xl font-bold tracking-tight mb-3">{m.title}</h3>
                <p className="font-body text-base text-muted-foreground leading-relaxed max-w-md">{m.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
